import React, { useState, useEffect } from 'react';
import { ThemeProvider } from 'styled-components';

import { useConfig } from './ConfigProvider';
import { Theme } from 'Types';
import themes from 'themes';
interface Props {
  children: React.ReactNode;
}
const ThemeProviderWrapper = ({ children }: Props) => {
  const config = useConfig();
  const oldTheme = themes[config.PACKAGE_SUFFIX];
  const [insets, setInsets] = useState({
    safeAreaInsetTop: 0,
    safeAreaInsetBottom: 0,
  });
  // This is used to test different colors and themes in Quickoffice before saving and instantly applying them.
  const [testingTheme, setTestingTheme] = useState<any>({});

  useEffect(() => {
    const root = document.documentElement;
    const safeAreaInsetTop = parseInt(getComputedStyle(root).getPropertyValue('--sat') || '0', 10);
    const safeAreaInsetBottom = parseInt(
      getComputedStyle(root).getPropertyValue('--sab') || '0',
      10,
    );

    setInsets({ safeAreaInsetTop, safeAreaInsetBottom });
  }, []);

  // Listen to messages from the iframe to update the theme dynamically.
  // This is for testing themes in Quickoffice.
  useEffect(() => {
    const listener = (event: MessageEvent) => {
      if (event.data.type === 'SET_COLOR' && event.data) {
        setTestingTheme((prev: any) => ({
          ...prev,
          ...event.data,
        }));
      }
    };

    window.addEventListener('message', listener);
    return () => window.removeEventListener('message', listener);
  }, []);

  const themeToUse: Theme = {
    main: testingTheme.main || config.THEME?.main || oldTheme.main,
    secondary: testingTheme.secondary || config.THEME?.secondary || oldTheme.secondary,
    contrastingColor:
      testingTheme.contrastingColor || config.THEME?.contrastingColor || oldTheme.contrastingColor,
    menuTextColor:
      testingTheme.menuTextColor || config.THEME?.menuTextColor || oldTheme.menuTextColor,
    priceColor: testingTheme.priceColor || config.THEME?.priceColor || oldTheme.priceColor,
    entryBackground:
      testingTheme.entryBackground || config.THEME?.entryBackground || oldTheme.entryBackground,
    menuBackgroundColor:
      testingTheme.menuBackgroundColor ||
      config.THEME?.menuBackgroundColor ||
      oldTheme.menuBackgroundColor,
  };

  return (
    <ThemeProvider
      theme={{
        ...themeToUse,
        safeAreaInsetBottom: insets.safeAreaInsetBottom,
        safeAreaInsetTop: insets.safeAreaInsetTop,
      }}>
      {children}
    </ThemeProvider>
  );
};

export default ThemeProviderWrapper;
